import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=2cb92d2d&scoped=true&"
import script from "./indexNew.vue?vue&type=script&lang=js&"
export * from "./indexNew.vue?vue&type=script&lang=js&"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=2cb92d2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb92d2d",
  null
  
)

export default component.exports